import(/* webpackMode: "eager" */ "/home/ubuntu/download/6996efc9f782d50014939a87/vanta/src/app/home/page.tsx");
